<template>
    <div>
        <div v-if="!somenteLeitura" class="prd-upload-box">
            <div class="columns is-vcentered is-multiline">
                <div class="column is-3">
                    <b-field label="Vincular ao item">
                        <b-select v-model="itemId" expanded placeholder="Orçamento geral">
                            <option :value="null">Orçamento geral</option>
                            <option v-for="(item, index) in itens" :key="item.id || index" :value="item.id || `novo-${index}`">
                                {{ item.sequencia }} — {{ item.descricao }}
                            </option>
                        </b-select>
                    </b-field>
                </div>
                <div class="column is-3">
                    <b-field label="Tipo">
                        <b-select v-model="tipo" expanded>
                            <option :value="1">Desenho técnico</option>
                            <option :value="2">Foto</option>
                            <option :value="3">Documento</option>
                            <option :value="4">Outro</option>
                        </b-select>
                    </b-field>
                </div>
                <div class="column is-6">
                    <b-field label="Arquivo (até 25 MB)">
                        <div class="prd-file-picker">
                            <b-upload v-model="arquivo" expanded accept=".pdf,.jpg,.jpeg,.png,.dwg,.dxf,.step,.stp">
                                <a class="button is-light is-fullwidth"
                                    ><b-icon icon="paperclip" />
                                    <span>{{ arquivo ? arquivo.name : 'Selecionar arquivo' }}</span>
                                </a>
                            </b-upload>
                            <b-button
                                type="is-primary"
                                icon-left="cloud-upload-outline"
                                :disabled="!arquivo"
                                :loading="enviando"
                                @click="enviar"
                            >
                                {{ orcamentoId ? 'Anexar' : 'Adicionar para envio' }}
                            </b-button>
                        </div>
                    </b-field>
                </div>
            </div>
        </div>

        <div v-if="pendentes.length" class="prd-file-list prd-pending-list">
            <div v-for="item in pendentes" :key="item.chave" class="prd-file-row">
                <div class="prd-file-icon"><b-icon :icon="icone(item.arquivo.name)" /></div>
                <div class="prd-file-info">
                    <strong>{{ item.arquivo.name }}</strong>
                    <small>{{ tamanho(item.arquivo.size) }} · Aguardando envio</small>
                </div>
                <b-button size="is-small" type="is-danger is-light" icon-left="delete-outline" @click="removerPendente(item)" title="Remover" />
            </div>
            <b-button v-if="orcamentoId && !somenteLeitura" type="is-primary" :loading="enviando" @click="enviarPendentes(orcamentoId, itens)">
                Enviar arquivos pendentes
            </b-button>
        </div>

        <prd-empty-state
            v-if="anexos.length === 0 && pendentes.length === 0"
            icon="paperclip"
            title="Nenhum arquivo anexado"
            description="Desenhos, fotos e documentos ficam centralizados aqui."
        />
        <div v-else class="prd-file-list">
            <div v-for="item in anexos" :key="item.id" class="prd-file-row">
                <div class="prd-file-icon"><b-icon :icon="icone(item.nomeOriginal)" /></div>
                <div class="prd-file-info">
                    <strong>{{ item.nomeOriginal }}</strong>
                    <small
                        >{{ tamanho(item.tamanho) }}<span v-if="item.itemId"> · Item {{ sequenciaItem(item.itemId) }}</span></small
                    >
                </div>
                <b-button size="is-small" type="is-light" icon-left="download" @click="baixar(item)" title="Baixar" />
                <b-button v-if="!somenteLeitura" size="is-small" type="is-danger is-light" icon-left="delete-outline" @click="remover(item)" title="Remover" />
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import prdEmptyState from './prdEmptyState.vue'

export default {
    name: 'PrdAnexos',
    components: { prdEmptyState },
    props: {
        orcamentoId: { type: Number, required: true },
        unidadeId: { type: Number, required: true },
        anexos: { type: Array, default: () => [] },
        itens: { type: Array, default: () => [] },
        somenteLeitura: Boolean,
    },
    data() {
        return { arquivo: null, itemId: null, tipo: 1, enviando: false, pendentes: [], proximaChave: 0 }
    },
    methods: {
        async enviar() {
            if (!this.arquivo) return
            if (!this.orcamentoId) {
                this.pendentes.push({
                    chave: ++this.proximaChave,
                    arquivo: this.arquivo,
                    tipo: this.tipo,
                    itemReferencia: this.itemId !== null ? this.itens[Number(String(this.itemId).replace('novo-', ''))] : null,
                    itemId: null,
                })
                this.arquivo = null
                this.itemId = null
                this.$buefy.toast.open({ message: 'Arquivo será enviado ao salvar o orçamento.', type: 'is-info' })
                return
            }
            this.enviando = true
            try {
                const form = new FormData()
                form.append('arquivo', this.arquivo)
                if (this.itemId) form.append('itemId', this.itemId)
                form.append('tipo', this.tipo)
                const res = await http.post(`/api/prd/orcamentos/${this.orcamentoId}/arquivos?unidadeId=${this.unidadeId}`, form)
                this.$emit('adicionado', res.data)
                this.arquivo = null
                this.$buefy.toast.open({ message: 'Arquivo anexado.', type: 'is-success' })
            } catch (error) {
                this.erro(error)
            } finally {
                this.enviando = false
            }
        },
        async enviarPendentes(orcamentoId, itens, itensAntesDeSalvar = []) {
            if (!this.pendentes.length) return true
            this.enviando = true
            let todosEnviados = true
            try {
                for (const pendente of [...this.pendentes]) {
                    try {
                        if (pendente.itemReferencia && !pendente.itemId) {
                            const indice = itensAntesDeSalvar.indexOf(pendente.itemReferencia)
                            const item = itens[indice]
                            if (indice < 0 || !item) throw new Error('Item do arquivo não encontrado.')
                            pendente.itemId = item.id
                        }
                        const form = new FormData()
                        form.append('arquivo', pendente.arquivo)
                        if (pendente.itemId) form.append('itemId', pendente.itemId)
                        form.append('tipo', pendente.tipo)
                        const res = await http.post(`/api/prd/orcamentos/${orcamentoId}/arquivos?unidadeId=${this.unidadeId}`, form)
                        this.$emit('adicionado', res.data)
                        this.removerPendente(pendente)
                    } catch (error) {
                        todosEnviados = false
                        this.erro(error)
                    }
                }
            } finally {
                this.enviando = false
            }
            return todosEnviados
        },
        removerPendente(item) {
            this.pendentes = this.pendentes.filter((x) => x.chave !== item.chave)
        },
        baixar(item) {
            window.open(`/api/prd/apoio/arquivos/${item.id}?unidadeId=${this.unidadeId}`, '_blank')
        },
        remover(item) {
            this.$buefy.dialog.confirm({
                title: 'Remover arquivo',
                message: `Remover “${item.nomeOriginal}” deste orçamento?`,
                confirmText: 'Remover',
                cancelText: 'Cancelar',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: async () => {
                    try {
                        await http.delete(`/api/prd/orcamentos/${this.orcamentoId}/arquivos/${item.id}?unidadeId=${this.unidadeId}`)
                        this.$emit('removido', item)
                    } catch (error) {
                        this.erro(error)
                    }
                },
            })
        },
        icone(nome) {
            const ext = (nome || '').split('.').pop().toLowerCase()
            return ext === 'pdf' ? 'file-pdf-box' : ['jpg', 'jpeg', 'png'].includes(ext) ? 'file-image-outline' : 'file-cad-box'
        },
        tamanho(bytes) {
            return bytes < 1048576 ? `${Math.ceil(bytes / 1024)} KB` : `${(bytes / 1048576).toFixed(1)} MB`
        },
        sequenciaItem(id) {
            const item = this.itens.find((x) => x.id === id)
            return item ? item.sequencia : '-'
        },
        erro(error) {
            this.$buefy.toast.open({ message: error.data?.erro || 'Não foi possível concluir a operação.', type: 'is-danger' })
        },
    },
}
</script>

<style scoped>
.prd-upload-box {
    background: #f7f9fc;
    border: 1px dashed #c9d5e3;
    border-radius: 12px;
    padding: 1rem;
    margin-bottom: 1rem;
}
.prd-file-picker {
    display: flex;
    align-items: stretch;
    gap: 0.5rem;
    width: 100%;
}
.prd-file-picker ::v-deep .upload {
    flex: 1;
    min-width: 0;
}
.prd-file-list {
    display: grid;
    gap: 0.5rem;
}
.prd-file-row {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    border: 1px solid #e7edf3;
    border-radius: 10px;
    padding: 0.65rem 0.75rem;
    background: white;
}
.prd-file-icon {
    color: #3273dc;
}
.prd-file-info {
    min-width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
}
.prd-file-info strong {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.prd-file-info small {
    color: #7b8794;
}
</style>
